import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ProjectModule } from 'modules/project/project.module';
import { OrganizationUnitListComponent } from 'modules/organization-units/organization-unit-list/organization-unit-list.component';
import { OrganizationUnitCardComponent } from 'modules/organization-units/organization-unit-card/organization-unit-card.component';
import { OrganizationUnitProjectListComponent } from 'modules/organization-units/organization-unit-project-list/organization-unit-project-list.component';
import { UpdateOrganizationUnitComponent } from 'modules/organization-units/update-organization-unit/update-organization-unit.component';
import { GetOrganizationUnitComponent } from 'modules/organization-units/get-organization-unit/get-organization-unit.component';
import { SharedModule } from 'modules/shared/shared.module';
import { TicketModule } from 'modules/ticket/ticket.module';

@NgModule({
  declarations: [
    OrganizationUnitListComponent,
    OrganizationUnitCardComponent,
    OrganizationUnitProjectListComponent,
    UpdateOrganizationUnitComponent,
    GetOrganizationUnitComponent,
  ],
  exports: [
    OrganizationUnitListComponent,
    OrganizationUnitCardComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ProjectModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatDialogModule,
    MatSnackBarModule,
    MatIconModule,
    TicketModule,
    RouterModule.forChild([
      {
        path: 'get/:id',
        component: GetOrganizationUnitComponent,
        canActivate: [],
      },
    ]),
  ],
  entryComponents: [
    UpdateOrganizationUnitComponent,
  ],
})
export class OrganizationUnitsModule { }
